
import utils from "../../../utils/utils.js";

export default {
    async fetchActiveLanguages(context) {
        const response = await utils.utility.fetch(`api/setting/getlanguages`, "GET", null, null);
  
        context.commit("setActiveLanguages", response.data);
    },
    async fetchTranslatedText(context, payload) {
        payload.text = payload.text.replaceAll("https://", " ").replaceAll("http://", " ").replaceAll("#", " ");

        const response = await utils.utility.fetch(`api/editor/gettranslatedtext?text=${payload.text}&translator=${payload.translator}&source=${payload.source}&target=${payload.target}`, "GET", null, null);

        context.commit("setTranslatedText", response.data);
    },
    async fetchIdentifyedLanguage(context, payload) {
        const response = await utils.utility.fetch(`api/editor/getidentifyedlanguage?text=${payload.text}&translator=${payload.translator}`, "GET", null, null);

        context.commit("setIdentifyedLanguage", response.data);
    },
    async fetchErrorExplanation(_, payload) {
        const response = await utils.utility.fetch("api/editor/explainerror", "POST", null, { errorMessage: payload.errorMessage }, true);

        return response.data;
    }
}